import { embedDashboard } from '@superset-ui/embedded-sdk'
import { Controller } from '@hotwired/stimulus'

export default class SupersetDashboardController extends Controller {
  static targets = ['supersetDashboard'];
  static values = {
    dashboardType: { type: String, default: 'maintenance' },
    height: { type: String, default: '138rem' }
  }

  connect () {
    this.loadDashboard()
  }

  loadDashboard () {
    const dashboardType = this.dashboardTypeValue || 'maintenance'
    const endpoint = `/api/v1/superset/${dashboardType}_dashboard`
    fetch(endpoint)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }
        return response.json()
      })
      .then((data) => {
        if (!data.available) {
          this.showUnavailableMessage(data.error || 'Analytics temporarily unavailable. Core CurbCMS features are unaffected.')
          return
        }

        const { guestToken, dashboardId, domain } = data
        this.embedDashboard(guestToken, dashboardId, domain)
      })
      .catch((error) => {
        console.error('Error loading dashboard:', error)
        this.showUnavailableMessage('Analytics temporarily unavailable. Core CurbCMS features are unaffected.')
      })
  }

  embedDashboard (guestToken, dashboardId, domain) {
    embedDashboard({
      id: dashboardId,
      supersetDomain: domain,
      mountPoint: this.supersetDashboardTarget,
      fetchGuestToken: () => guestToken,
      dashboardUiConfig: { hideTitle: true }
    })

    const iframe = this.supersetDashboardTarget.querySelector('iframe')

    if (iframe) {
      iframe.style.width = '100%'
      iframe.style.height = this.heightValue
    }
  }

  showUnavailableMessage (errorMessage) {
    this.supersetDashboardTarget.innerHTML = `
      <div class="flex flex-col items-center justify-center h-96 p-8 text-center bg-gray-50 rounded-lg border border-gray-200">
        <div class="mb-4">
          <svg class="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-700 mb-2">Analytics Temporarily Unavailable</h3>
        <p class="text-gray-600 mb-4 max-w-md">${errorMessage}</p>
      </div>
    `
  }
}
